// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-4157be7c] .v-tabs-slider-wrapper{display:block!important}@media screen and (max-width:600px){.v-tabs[data-v-4157be7c] .v-slide-group__prev{display:none!important}}", ""]);
// Exports
module.exports = exports;
